module.exports = __webpack_public_path__ + "img/6_38.d3456c4d.png";